import { useState,useEffect } from "react";
import InfoEvalPerformance from "./Components/InfoEvalPerformance";
import InfoEvalPerformanceCollaborator from "./Components/InfoEvalPerformanceCollaborator";
import InfoCompetencesQualification from "./Components/InfoCompetencesQualification";
import { IPerformanceEvaluationQualification } from '../../interfaces/PerformanceEvaluationQualification.interface';
import { useQuery,useMutation  } from "@apollo/client";
import { GET_INFO_EVALUATION_PERFORMANCE,
         CREATE_ADD_ANSWERS_PER_EVAL } 
from "../../Querys/performanceEvaluationQualification/querys";
import { Grid } from '@material-ui/core';
import { actualizarObjetoEnArray } from "../../helpers/ArraysHelpers";
import { SuccessfulAlert } from "../../alerts/successAlerts";
import { LoadingDb } from "../../alerts/loadingAlerts";
import BtnTerminar from "./Components/BtnTerminar";
import { isAfter,parse } from 'date-fns';
import "./css/EvalPerformanceQual.css"

type PerformanceEvaluationQualificationProps ={
    typeUser:string,    
    token:string      
}

const validarChecked=(arr:any)=> {
  return arr.every((obj:any) => obj.hasOwnProperty('checked') && obj.checked === true);
}

const currentDate = new Date();

const convertLowercase=(text:string)=>{
    let textLower = text.toLowerCase();
    let textoSinAcentos = textLower.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return textoSinAcentos } 

const PerformanceEvaluationQualification = ({typeUser,token}:PerformanceEvaluationQualificationProps) => {
    const [performanceEvalInfo, setPerformanceEvalInfo] = useState<IPerformanceEvaluationQualification[]>([]);
    const [qualPerfEval, setQualPerfEval] = useState<any>([]);    
    const [competencies, setCompetencies] = useState<any>([]);    
    const [disabledBtnSend,setDisabledBtnSend]=useState(true); 
    const [disabledAll,setDisabledAll]=useState(false);         
    const variables={ token,type: typeUser }   
    const { data ,loading} = useQuery(GET_INFO_EVALUATION_PERFORMANCE, {variables: {input:variables }, });    
    const resPerformanceEvalInfo = data?.GET_INFO_EVALUATION_PERFORMANCE;  
    const [createQualificationEval] = useMutation(CREATE_ADD_ANSWERS_PER_EVAL,{
      refetchQueries: [
         { 
          query: GET_INFO_EVALUATION_PERFORMANCE ,
          variables: { input:variables},
        }
    ],
     });
   
    useEffect(() => { 
        if (data?.GET_INFO_EVALUATION_PERFORMANCE){
            if(resPerformanceEvalInfo.length >0){              
               setPerformanceEvalInfo(resPerformanceEvalInfo)  
               setCompetencies(resPerformanceEvalInfo[0].competencies)       
               if(resPerformanceEvalInfo[0].evaluationQualStatus ==='qualified')
                {
                  setDisabledBtnSend(true)
                }          
            }
         } }, [data?.GET_INFO_EVALUATION_PERFORMANCE, performanceEvalInfo, resPerformanceEvalInfo]);  
         
    const handleClickEvalPerSel=(event:any,idCompetencies:number)=>{
     
      const nuevasPropiedades = { idQual:parseInt(event.target.id), calificacion:convertLowercase(event.target.name)};
      const updatedCompetencies=actualizarObjetoEnArray(competencies,'idCompetencies',idCompetencies,nuevasPropiedades)      
      setCompetencies(updatedCompetencies)    
      const objQual={ 
       token,  
       idQual:event.target.id, 
       idCompetencies,    
       typeUser,
       qualification:convertLowercase(event.target.name),
       checked:event.target.checked
      }  
      const index = qualPerfEval.findIndex((item:any) => item.idCompetencies === idCompetencies);
      if (index === -1) {
       setQualPerfEval([...qualPerfEval,  objQual]);      
      } 
     else {    
       const updatedQualPerfEval = [...qualPerfEval];
       updatedQualPerfEval[index] = objQual;
       setQualPerfEval(updatedQualPerfEval);       
     }         
    }

    const sendEvaluation= async ()=>{     
      qualPerfEval.forEach((obj:any) => delete obj.checked);
      LoadingDb();
      await createQualificationEval({
        variables:{                   
          input: qualPerfEval,
        }});
      setQualPerfEval([])  
      SuccessfulAlert({ text: 'La evaluación ha sido contestada con éxito.'})
    }

 useEffect(() => {    
    if(competencies.length >0){
    if(qualPerfEval.length === competencies.length ){
      if(validarChecked(qualPerfEval))
        {setDisabledBtnSend(false)} else{setDisabledBtnSend(true)}
    }
 }
}, [competencies.length, performanceEvalInfo, qualPerfEval]);

useEffect(() => {    
  if(competencies.length >0){
       
    if(!isAfter(parse(performanceEvalInfo[0].dateClose,'dd/MM/yyyy',new Date()), currentDate)){
      return setDisabledAll(true)
    }

    if(performanceEvalInfo[0].active ==='Inactivo' || performanceEvalInfo[0].step ==='retroalimentacion'){
      return setDisabledAll(true)
    }
}
}, [competencies.length, performanceEvalInfo]);
         
  return (
    <>
    {
     (loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
        :
    <>
    <Grid className="containerInfoQual">
     <Grid>
       <Grid style={{ marginLeft: 0, marginTop: 0 }}>
        {performanceEvalInfo.length >0 &&
        <>
        <InfoEvalPerformance 
            namePerformance={performanceEvalInfo[0].namePerformance}
            description={performanceEvalInfo[0].description}            
            periodo={performanceEvalInfo[0].period}
        />        
        <InfoEvalPerformanceCollaborator
            nameComplete={performanceEvalInfo[0].businessName}
            email={performanceEvalInfo[0].email}
            sede={performanceEvalInfo[0].campus}
            proyecto={performanceEvalInfo[0].project}
            dateAdmission={performanceEvalInfo[0].dateAdmission}
        />
        </>
        }
      </Grid>           
     </Grid>    
    </Grid>
    { 
     performanceEvalInfo.length >0 &&
       competencies.length> 0 &&
       competencies?.map((comp: any) => {
        return (
        <InfoCompetencesQualification
            key={comp.idCompetencies}
            competencia={comp}            
            qualPerfEval={qualPerfEval}
            addQualification={handleClickEvalPerSel}                
            disabledFunc={disabledAll }
         />     

        )
      })      
    }
    <Grid className="containerBtnEval">
        <BtnTerminar
              txtBtn="Terminar evaluación"   
              execFunc={sendEvaluation}                       
              disabledBtn={disabledBtnSend}
             />
    </Grid>     
    </>    
    }
    </>
  )
}

export default PerformanceEvaluationQualification